export default __webpack_public_path__ + "images/onboarding/home_illustration-cda214b200f242d789bc98718ba4592c.svg";